/**
 * Spread onto every text `Input` in the Connection API section: these are
 * operational identifiers (key names, clinic ids, exchange ids, API keys),
 * and password managers / autofill extensions must keep their icons and
 * suggestions out of them. One constant so a newly discovered vendor flag is
 * added in exactly one place.
 */
export const AUTOFILL_OFF = {
  autoComplete: 'off',
  inputFieldProps: {
    'data-1p-ignore': true, // 1Password
    'data-lpignore': 'true', // LastPass
    'data-bwignore': true, // Bitwarden
    'data-form-type': 'other', // Dashlane's documented field-type signal
    'data-dashlane-ignore': 'true',
  },
} as const;
